var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.041,
    height: 20.001,
    viewBox: "0 0 16.041 20.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bell",
    d: "M18.035,13.208V10.02A6.015,6.015,0,0,0,13.023,4.1V3a1,1,0,1,0-2.005,0V4.1A6.015,6.015,0,0,0,6.005,10.02v3.188A3.008,3.008,0,0,0,4,16.035V18.04a1,1,0,0,0,1,1H8.15a4.01,4.01,0,0,0,7.74,0h3.148a1,1,0,0,0,1-1V16.035a3.008,3.008,0,0,0-2.005-2.827ZM8.01,10.02a4.01,4.01,0,0,1,8.02,0v3.008H8.01Zm4.01,10.025a2.005,2.005,0,0,1-1.724-1h3.449A2.005,2.005,0,0,1,12.02,20.046Zm6.015-3.008H6.005v-1a1,1,0,0,1,1-1H17.033a1,1,0,0,1,1,1Z",
    transform: "translate(-4 -2)",
    fill: "#a0a0a0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.b78e7c0a7f91c8033ca9f241f73fe5eb.svg";
export { ForwardRef as ReactComponent };